/**
 * @generated SignedSource<<77ca1943e2b3911b3fa6360fcd9ebe93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SignupMode = "INVITE" | "OPEN" | "%future added value";
export type SessionProviderQuery$variables = Record<PropertyKey, never>;
export type SessionProviderQuery$data = {
  readonly authStatus: {
    readonly enabled: boolean;
    readonly signupMode: SignupMode;
  };
  readonly viewer: {
    readonly canAccessFinancas: boolean;
    readonly email: string;
    readonly id: string;
    readonly name: string;
  } | null | undefined;
};
export type SessionProviderQuery = {
  response: SessionProviderQuery$data;
  variables: SessionProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canAccessFinancas",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthStatus",
    "kind": "LinkedField",
    "name": "authStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signupMode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionProviderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4d7f89ae85c84a4d332f9077a9168d20",
    "id": null,
    "metadata": {},
    "name": "SessionProviderQuery",
    "operationKind": "query",
    "text": "query SessionProviderQuery {\n  viewer {\n    id\n    name\n    email\n    canAccessFinancas\n  }\n  authStatus {\n    enabled\n    signupMode\n  }\n}\n"
  }
};
})();

(node as any).hash = "696b68ffcd015cf2b613d21021f31755";

export default node;
